module.exports = __webpack_public_path__ + "static/keijiban-banner-8903d44ba10b2be3d3ab66dfe944f312.svg";